
//系统目录 / 毒麻类型 接口相关的函数
import request from "../../untils/request.js"

/**
 * 
 *  post
 *  
 */

//新建一个毒麻类型
export const addPoisonAnesthesia = (data) => {
    return request.post("/outpatient/addPoisonAnesthesia", data )
}

//修改一个毒麻类型
export const updatePoisonAnesthesia = (data) => {
    return request.post("/outpatient/updatePoisonAnesthesia", data )
}


/**
 * 
 * get 
 *  
 */

// 树菜单
export const AllTree = (params) => {
    return request.get("/outpatient/selectAllDrugCategory", { params })
}

// 获取毒麻类型
export const selectDocVtByType = (params) => {
    return request.get("/outpatient/selectDocVtByType", { params })
}

/*
 * 
 * DELETE 
 *   
 */   
// 删除毒麻类型
export const deleteByPoison = (data) => {
  return request.delete("/outpatient/deleteByPoison", { data })
}

// 暴露
export default{
	AllTree,
	addPoisonAnesthesia,updatePoisonAnesthesia,selectDocVtByType,deleteByPoison
}